import React from "react";
import { Box, Container, Grid, Typography, Avatar, Paper } from "@mui/material";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import person from "../../images/person.png";

const FounderMsg = () => {
  return (
    <Box
      component="section"
      sx={{
        py: { xs: 8, md: 12 },
        background: "#fff",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Decorative Elements */}
      <Box
        sx={{
          position: "absolute",
          top: -100,
          right: -100,
          width: 300,
          height: 300,
          borderRadius: "50%",
          background: "rgba(26, 66, 161, 0.03)",
          zIndex: 0,
        }}
      />

      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={4} lg={4}>
            <Box
              sx={{
                position: "relative",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Paper
                elevation={20}
                sx={{
                  borderRadius: "20px",
                  overflow: "hidden",
                  width: { xs: "280px", md: "100%" },
                  maxWidth: "350px",
                  border: "8px solid #fff",
                }}
              >
                <img
                  src={person}
                  alt="Mr. Vardhman Doogar"
                  style={{
                    width: "100%",
                    height: "auto",
                    display: "block",
                    filter: "grayscale(20%)",
                  }}
                />
              </Paper>
              <Box
                sx={{
                  position: "absolute",
                  bottom: -20,
                  right: -20,
                  bgcolor: "var(--primary-color)",
                  color: "#fff",
                  p: 2,
                  borderRadius: "12px",
                  display: { xs: "none", sm: "block" },
                  boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    lineHeight: 1,
                    color: "var(--treasury-color)",
                  }}
                >
                  29+ Years
                </Typography>
                <Typography variant="caption" sx={{ opacity: 0.8 }}>
                  of Excellence
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} md={8} lg={8}>
            <Box sx={{ pl: { md: 4 } }}>
              <FormatQuoteIcon
                sx={{
                  fontSize: 60,
                  color: "var(--primary-color)",
                  opacity: 0.2,
                  mb: -2,
                  ml: -1,
                }}
              />
              <Typography
                variant="h3"
                sx={{
                  fontWeight: 800,
                  mb: 3,
                  color: "var(--text-color)",
                  fontSize: { xs: "2rem", md: "2.5rem" },
                  fontFamily: "'Roboto Slab', serif",
                }}
              >
                Managing Partner’s{" "}
                <span style={{ color: "var(--primary-color)" }}>Message</span>
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  fontSize: "1.1rem",
                  lineHeight: 1.8,
                  color: "#555",
                  mb: 4,
                  fontStyle: "italic",
                  textAlign: "justify",
                }}
              >
                "The world is moving faster than ever, and change has become the
                only constant we must all embrace. To remain competitive and
                thrive amidst these changes, global businesses need strong local
                guidance and the right partners by their side. VDA’s journey has
                always been defined by one purpose—helping our clients succeed.
                Today, as a global advisory firm, we proudly work with more than
                100 companies worldwide, providing solutions that blend local
                insight with international expertise. Every project we undertake
                reflects our core values: integrity, agility, and excellence.
                Looking ahead, we remain dedicated to creating value, building
                trust, and guiding our clients to achieve their strategic goals
                with certainty."
              </Typography>

              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Box
                  sx={{
                    width: 50,
                    height: 2,
                    bgcolor: "var(--primary-color)",
                  }}
                />
                <Box>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 700, color: "var(--text-color)" }}
                  >
                    Mr. Vardhman Doogar
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    sx={{ color: "var(--primary-color)", fontWeight: 600 }}
                  >
                    Managing Partner
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default FounderMsg;
